import { render } from "./App.vue?vue&type=template&id=e4b522fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e4b522fc&lang=scss"

import exportComponent from "/Users/elkemoras/Desktop/sites/www/ugent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__